import RasterImageProcessor from 'RasterImageProcessor';

class ImageProcessor {
  #worker = new RasterImageProcessor();
  #imageData = null;
  #processedPixels = null;
  #params = null;
  #action = null;
  #resolve;

  constructor() {
    this.#worker.onmessage = this.handleMessage;
  }

  handleMessage = event => {
    const data = event.data;

    if (data.status === 'finished') {
      this.#imageData = data.imgData;
      this.#processedPixels = data.processedPixels;
        this.#resolve();
    }
  }

  async processImageData() {
    const params = {
      imgData: this.#imageData,
      filter: this.#action,
      args: this.#params,
    };

    return new Promise((resolve) => {
      this.#resolve = resolve;
      this.#worker.postMessage(params);
    });
  }


  setImageData(imageData) {
    this.#imageData = imageData;
    return this;
  }

  setParams(params) {
    this.#params = params;
    return this;
  }

  setAction(action) {
    this.#action = action;
    return this;
  }

  getImageData() {
    return this.#imageData;
  }

  getProcessedPixels() {
    return this.#processedPixels;
  }
}

export default ImageProcessor;